/** Incremental order-book merge (Gereh handleIncrementalUpdate). */

function sortAsks(data) {
  return [...data].sort((a, b) => +a[0] - +b[0]);
}

function sortBids(data) {
  return [...data].sort((a, b) => +b[0] - +a[0]);
}

export function handleIncrementalUpdate(depthOld, newLevel, type) {
  if (!Array.isArray(newLevel) || newLevel.length !== 2) return depthOld || [];

  const prev = depthOld || [];
  const index = prev.findIndex(([price]) => +price === +newLevel[0]);

  if (index === -1 && +newLevel[1]) {
    const data = [...prev, newLevel];
    return type === "asks" ? sortAsks(data) : sortBids(data);
  }

  const result = [...prev];
  if (Number(newLevel[1]) !== 0) {
    result[index] = newLevel;
  } else {
    result.splice(index, 1);
  }

  return type === "asks" ? sortAsks(result) : sortBids(result);
}

export function handleIncrementalUpdateArray(depthOld, newLevels, type) {
  const prices = {};
  (newLevels || []).forEach((lvl) => {
    if (Array.isArray(lvl) && lvl.length >= 2) prices[lvl[0]] = lvl[1];
  });

  const rest = (depthOld || []).filter(([price]) => prices[price] === undefined);
  const newData = (newLevels || []).filter((lvl) => Number(lvl[1]) !== 0);
  const result = [...rest, ...newData];
  return type === "asks" ? sortAsks(result) : sortBids(result);
}

export function applyDepthIncrement(state, event) {
  let asks = state.asks || [];
  let bids = state.bids || [];

  if (event.asks) {
    asks = Array.isArray(event.asks[0])
      ? handleIncrementalUpdateArray(asks, event.asks, "asks")
      : handleIncrementalUpdate(asks, event.asks, "asks");
  }
  if (event.bids) {
    bids = Array.isArray(event.bids[0])
      ? handleIncrementalUpdateArray(bids, event.bids, "bids")
      : handleIncrementalUpdate(bids, event.bids, "bids");
  }

  return {
    ...state,
    asks,
    bids,
    sequence: event.sequence != null ? event.sequence : state.sequence,
  };
}

export function depthToShahooBook(asks, bids, limit = 16) {
  const toLevels = (rows) =>
    (rows || [])
      .map((row) => ({
        unitPrice: parseFloat(row[0]) || 0,
        size: parseFloat(row[1]) || 0,
      }))
      .filter((r) => r.unitPrice > 0 && r.size > 0);

  return {
    sells: toLevels(asks).slice(0, limit),
    buys: toLevels(bids).slice(0, limit),
  };
}

export function snapshotToDepth(event) {
  return {
    asks: event?.asks || [],
    bids: event?.bids || [],
    sequence: event?.sequence != null ? Number(event.sequence) : null,
    loading: false,
  };
}
